import { Trans } from "@web-monorepo/i18n/macro";
import { useSideEffectOnMount, useWatch } from "@web-monorepo/hooks";
import logEvent from "src/utils/logEvent";
import activities from "./activities";

type ConundrumDisplayRendererProps = {
  params: {
    conundrumName: string;
    stepName: string;
  };
};

export default function ConundrumDisplayRenderer({ params }: ConundrumDisplayRendererProps) {
  const { conundrumName, stepName } = params;

  useSideEffectOnMount(() => {
    logEvent({ eventName: `conundrums.${conundrumName}.${stepName}` });
  });

  // Re-log when navigating between slides while mounted (replaces the
  // pre-migration UNSAFE_componentWillReceiveProps). `immediate: false`
  // because useSideEffectOnMount above already fires the initial log —
  // without it useWatch would double-log on the first render.
  useWatch(
    [conundrumName, stepName],
    () => {
      logEvent({ eventName: `conundrums.${conundrumName}.${stepName}` });
    },
    { immediate: false },
  );

  const definition = activities[conundrumName];
  const index = parseInt(stepName, 10);
  const Slide = definition?.[index]?.display;
  if (!Slide) {
    return (
      <div>
        <Trans>
          Couldn't find slide for {{ conundrumName }} {{ index }} (display)
        </Trans>
      </div>
    );
  }
  return <Slide />;
}
